import React from "react";
import { ButtonBase } from "@mui/material";
import Title from "../typography/Title";
import { AvailableLoanOptionButton } from "../icons/available-loan-option-buton";

export const LoanOptionButtonSmall = ({
  subtitle,
  onClick,
  selected,
  title,
}) => (
  <ButtonBase
    className={
      selected
        ? "loan-option-button-base-small selected"
        : "loan-option-button-base-small"
    }
    onClick={onClick}
    disableRipple
  >
    <div className="loan-option-button-background">
      <AvailableLoanOptionButton width={50} height={65} />
    </div>
    <div className="loan-option-button-title-small">{title}</div>
    <span className="loan-option-button-subtitle-small">{subtitle}</span>
  </ButtonBase>
);
